enum UserRoleTypeEnum {
  ADMIN = "ADMIN",
  USER = "USER",
  VIEWER = "VIEWER",
  DRIVER = "DRIVER",
  WASTE_MANAGER = "WASTE_MANAGER",
  LOGISTICS_COORDINATOR = "LOGISTICS_COORDINATOR",
}

export default UserRoleTypeEnum;
